$(document).ready(function () {
  const circle_green_full = `
    <svg class="circle_green_full" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="8" fill="#39C177"/>
    <defs>
    <clipPath id="clip0_1721_6136">
    <rect width="9.6" height="9.6" fill="white" transform="translate(3.19922 3.19922)"/>
    </clipPath>
    </defs>
    </svg>
  `;

  const circle_green_checked = `
    <svg class="circle_green_checked" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="8" fill="#39C177"/>
    <g clip-path="url(#clip0_1721_6136)">
    <path d="M4.06445 8.56323L6.31364 10.8124L11.9366 5.18945" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_1721_6136">
    <rect width="9.6" height="9.6" fill="white" transform="translate(3.19922 3.19922)"/>
    </clipPath>
    </defs>
    </svg>
  `;

  const circle_orange_hg = `
    <svg class="circle_orange_hg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="8" fill="#F99B0E"/>
    <g clip-path="url(#clip0_1721_6304)">
    <path d="M11 12V11C11 10.05 10.55 9.1 9.75 8.55C9.6 8.45 9.5 8.3 9.5 8.15V7.85C9.5 7.7 9.6 7.55 9.75 7.45C10.55 6.9 11 5.95 11 5V4C11.3 4 11.5 3.8 11.5 3.5C11.5 3.2 11.3 3 11 3H5C4.7 3 4.5 3.2 4.5 3.5C4.5 3.8 4.7 4 5 4V5C5 5.95 5.45 6.9 6.25 7.45C6.4 7.55 6.5 7.7 6.5 7.85V8.1C6.5 8.25 6.4 8.4 6.25 8.5C5.45 9.1 5 10.05 5 11V12C4.7 12 4.5 12.2 4.5 12.5C4.5 12.8 4.7 13 5 13H11C11.3 13 11.5 12.8 11.5 12.5C11.5 12.2 11.3 12 11 12ZM6 11C6 10.35 6.3 9.75 6.85 9.35C7.25 9.05 7.5 8.6 7.5 8.15V7.85C7.5 7.35 7.25 6.9 6.85 6.6C6.3 6.25 6 5.65 6 5V4H10V5C10 5.65 9.7 6.25 9.15 6.65C8.75 6.95 8.5 7.4 8.5 7.85V8.1C8.5 8.6 8.75 9.05 9.15 9.35C9.7 9.75 10 10.35 10 11V12H6V11Z" fill="white"/>
    </g>
    <defs>
    <clipPath id="clip0_1721_6304">
    <rect width="10" height="10" fill="white" transform="translate(3 3)"/>
    </clipPath>
    </defs>
    </svg>
  `;

  const circle_blue_hg = `
    <svg class="circle_blue_hg" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8.70508" r="8" fill="#3753C7"/>
    <g clip-path="url(#clip0_1721_5976)">
    <path d="M11 12.7051V11.7051C11 10.7551 10.55 9.80508 9.75 9.25508C9.6 9.15508 9.5 9.00508 9.5 8.85508V8.55508C9.5 8.40508 9.6 8.25508 9.75 8.15508C10.55 7.60508 11 6.65508 11 5.70508V4.70508C11.3 4.70508 11.5 4.50508 11.5 4.20508C11.5 3.90508 11.3 3.70508 11 3.70508H5C4.7 3.70508 4.5 3.90508 4.5 4.20508C4.5 4.50508 4.7 4.70508 5 4.70508V5.70508C5 6.65508 5.45 7.60508 6.25 8.15508C6.4 8.25508 6.5 8.40508 6.5 8.55508V8.80508C6.5 8.95508 6.4 9.10508 6.25 9.20508C5.45 9.80508 5 10.7551 5 11.7051V12.7051C4.7 12.7051 4.5 12.9051 4.5 13.2051C4.5 13.5051 4.7 13.7051 5 13.7051H11C11.3 13.7051 11.5 13.5051 11.5 13.2051C11.5 12.9051 11.3 12.7051 11 12.7051ZM6 11.7051C6 11.0551 6.3 10.4551 6.85 10.0551C7.25 9.75508 7.5 9.30508 7.5 8.85508V8.55508C7.5 8.05508 7.25 7.60508 6.85 7.30508C6.3 6.95508 6 6.35508 6 5.70508V4.70508H10V5.70508C10 6.35508 9.7 6.95508 9.15 7.35508C8.75 7.65508 8.5 8.10508 8.5 8.55508V8.80508C8.5 9.30508 8.75 9.75508 9.15 10.0551C9.7 10.4551 10 11.0551 10 11.7051V12.7051H6V11.7051Z" fill="white"/>
    </g>
    <defs>
    <clipPath id="clip0_1721_5976">
    <rect width="10" height="10" fill="white" transform="translate(3 3.70508)"/>
    </clipPath>
    </defs>
    </svg>
  `;

  const circle_gray_qm = `
    <svg class="circle_gray_qm" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8.70508" r="8" fill="#9FA6AB"/>
    <path d="M7.86105 3.3156C8.86316 3.3156 9.66386 3.59069 10.2632 4.14087C10.8723 4.69104 11.1768 5.44262 11.1768 6.3956C11.1768 7.38788 10.8625 8.13455 10.2337 8.6356C9.60491 9.13666 8.76982 9.38718 7.72842 9.38718L7.66947 10.5514H6.21053L6.13684 8.23771H6.62316C7.57614 8.23771 8.30316 8.10999 8.80421 7.85455C9.31509 7.59911 9.57053 7.1128 9.57053 6.3956C9.57053 5.8749 9.41825 5.46718 9.11368 5.17245C8.81895 4.87771 8.40632 4.73034 7.87579 4.73034C7.34526 4.73034 6.92772 4.8728 6.62316 5.15771C6.3186 5.44262 6.16632 5.84052 6.16632 6.35139H4.58947C4.58947 5.76192 4.72211 5.23631 4.98737 4.77455C5.25263 4.3128 5.63088 3.9542 6.12211 3.69876C6.62316 3.44332 7.20281 3.3156 7.86105 3.3156ZM6.91789 13.8082C6.61333 13.8082 6.35789 13.7051 6.15158 13.4988C5.94526 13.2924 5.84211 13.037 5.84211 12.7324C5.84211 12.4279 5.94526 12.1724 6.15158 11.9661C6.35789 11.7598 6.61333 11.6567 6.91789 11.6567C7.21263 11.6567 7.46316 11.7598 7.66947 11.9661C7.87579 12.1724 7.97895 12.4279 7.97895 12.7324C7.97895 13.037 7.87579 13.2924 7.66947 13.4988C7.46316 13.7051 7.21263 13.8082 6.91789 13.8082Z" fill="white"/>
    </svg>
  `;

  let page_brands = [];

  const getIcon = (lieferanzeige, fallback) => {
    console.log('lieferanzeige',lieferanzeige, fallback)
    let icon;
    switch (lieferanzeige) {
      case "Lieferbar ab Lager - Icon (Green full checkmark)":
        icon = circle_green_checked;
        break;

      case "Dropshipping lieferbar - Icon (Green full dot)":
        icon = circle_green_full;
        break;

      case "Liefertermin bekannt - Icon (Blue with Sandbox)":
        icon = circle_orange_hg;
        break;

      case "Liefertermin unbekannt - icon (Grey with questionmark)":
        icon = circle_gray_qm;
        break;

      default:
        icon = fallback;
        break;
    }
    return icon;
  };

  const setDeliveryRules = async (elm, location = "card") => {
    let vendor = elm.data("vendor"),
      dropshipping = elm.data("dropshipping"),
      nachlieferung = elm.data("nachlieferung"),
      has_nachlieferung = elm.data("has_nachlieferung"),
      in_stock = elm.data("in_stock"),
      lieferanzeige = elm.data("lieferanzeige"),
      placeholder = $(".product__delivery", elm),
      icon = $("p", placeholder),
      label;

    in_stock = parseInt(elm.data("stock")) > 0;

    if (location === "details") {
      icon = $(".pro_custom_fields .cf_lieferzeit_icon", elm);
      placeholder = $(".cf_lieferzeit span", elm);
      label = $(".cf_lieferzeit b", elm);
    }
    if (location === "cart") {
      // console.log('elm',elm)
      icon = $(".cart-item__lieferung .cf_lieferzeit_icon", elm);
      placeholder = $(".product__delivery", elm);
      // label = $(".cf_lieferzeit b", elm);
    }

    if (has_nachlieferung) {
      let date = new Date(nachlieferung);
      nachlieferung = date.toLocaleDateString("de-DE"); // Formats to DD.MM.YYYY
    }

    const setData = (labelText, deliveryText, iconHtml) => {
      icon.html(iconHtml);
      if (location === "cart") {
        let finalText = deliveryText ? deliveryText : labelText;
        placeholder.text(finalText);
      } else if (location === "details") {
        label.text(labelText);
        placeholder.text(deliveryText);
      } else {
        placeholder.attr("data-liefertage", labelText + " " + deliveryText);
      }
      $(".pro_custom_fields-skeleton-loader").remove();
      //console.log("deliveryText", deliveryText);
    };

    let test = 0;
    if (!dropshipping) {
      if (in_stock) {
        if (has_nachlieferung) {
          setData(
            `${window.productStrings.deliveryDate}:`,
            `1-2 ${window.productStrings.workingDays}`,
            getIcon(lieferanzeige, circle_green_checked)
          );
          // console.log(`case 1`, location);
          test = 1;
        } else {
          setData(
            `${window.productStrings.deliveryDate}:`,
            `1-2 ${window.productStrings.workingDays}`,
            getIcon(lieferanzeige, circle_green_checked)
          );
          // console.log(`case 2`, location);
          test = 2;
        }
      } else {
        if (has_nachlieferung) {
          setData(
            `${window.productStrings.deliveryDate}:`,
            nachlieferung,
            getIcon(lieferanzeige, circle_orange_hg)
          );
          // console.log(`case 3`, location);
          test = 3;
        } else {
          setData(
            `${window.productStrings.deliveryDateUnknown}`,
            ``,
            getIcon("", circle_gray_qm)
          );
          // console.log(`case 4`, location);
          test = 4;
        }
      }
    } else {
      if (has_nachlieferung) {
        setData(
          `${window.productStrings.deliveryDate}:`,
          nachlieferung,
          getIcon(lieferanzeige, circle_orange_hg)
        );
        // console.log(`case 5`, location);
        test = 5;
      } else if (in_stock) {
        setData(
          `${window.productStrings.deliveryDate}:`,
          `1-2 ${window.productStrings.workingDays}`,
          getIcon(lieferanzeige, circle_green_checked)
        );
        // console.log(`case exception`, location);
        test = exception;
      } else {
        page_brands.push(vendor);
        // console.log(`case 6`, location);
        test = 6;
      }
    }

    // console.log("🔴🔴", elm[0], dropshipping, in_stock, has_nachlieferung, test, vendor)
    console.log("🔴🔴", elm[0], test, vendor)

    $(".product__delivery").removeClass("hidden");
    setBrandDays();
  };

  // console.log('fffffffffffff');
  $(".product-card-wrapper").each(function () {
    let card = $(this);
    setDeliveryRules(card);
  });
  subscribe("collection-loaded", (e) => {
    setTimeout(function () {
      $(".product-card-wrapper").each(function () {
        let card = $(this);
        setDeliveryRules(card);
      });
    }, 1000);
  });
  subscribe("wishlist-loaded", (e) => {
    $(".uwl-product-iteam").each(function () {
      let card = $(this);
      setDeliveryRules(card);
    });
  });

  $(".product__info-wrapper").each(function () {
    // console.log('rrrrr');
    let product = $(this);
    setDeliveryRules(product, "details");
  });

  $("tr.cart-item[data-handle]").each(function () {
    let item = $(this);
    setDeliveryRules(item, "cart");
  });
  subscribe("cart-item-update", (e) => {
    $("tr.cart-item[data-handle]").each(function () {
      let item = $(this);
      setDeliveryRules(item, "cart");
    });
  });

  // to reduce api calls, list unique brands and make single call
  // for each brand instead of each card and set for all brands using
  // data-vendor attribute
  // fetchNumberOfDeliveryDays function is defined in custom.js
  function setBrandDays() {
    page_brands = [...new Set(page_brands)];
    // console.log("page_brands", page_brands.length);
    if (page_brands.length) {
      // console.log("page_brands", page_brands);
      page_brands.forEach(async (vendor) => {
        // let brand = vendor === "ROTH-KIPPE" ? "Roth Kippe" : vendor;
        let brand = vendor;
        try {
          let brandData = await fetchNumberOfDeliveryDays(brand);
          let cardSelector = `.product-card-wrapper[data-vendor="${vendor}"]`;
          let detailsSelector = `.product__info-wrapper[data-vendor="${vendor}"]`;
          let itemSelector = `tr.cart-item[data-vendor="${vendor}"]`;
          // console.log('brandDatabrandDatabrandDatabrandDatabrandData',brandData);
          if (brandData && brandData.numberOfDeliveryDays) {
            if ($(cardSelector).length) {
              $(cardSelector).each(function () {
                let dropshipping = $(this).data("dropshipping"),
                  has_nachlieferung = $(this).data("has_nachlieferung"),
                  lieferanzeige = $(this).data("lieferanzeige");

                if (dropshipping && !has_nachlieferung) {
                  $(".product__delivery", $(this)).attr(
                    "data-liefertage",
                    `${window.productStrings.deliveryDate}: ${brandData.numberOfDeliveryDays} ${window.productStrings.workingDays}`
                  );
                  // console.log("lieferanzeige", lieferanzeige);
                  $(".product__delivery p", $(this)).html(
                    getIcon(lieferanzeige, circle_green_full)
                  );
                }
              });
            }

            if ($(detailsSelector).length === 1) {
              let dropshipping = $(detailsSelector).data("dropshipping"),
                has_nachlieferung =
                  $(detailsSelector).data("has_nachlieferung"),
                lieferanzeige = $(detailsSelector).data("lieferanzeige");

              if (dropshipping && !has_nachlieferung) {
                $(".cf_lieferzeit span", $(detailsSelector)).text(
                  `${brandData.numberOfDeliveryDays} ${window.productStrings.workingDays}`
                );
                // console.log("lieferanzeige", lieferanzeige);
                $(".cf_lieferzeit_icon", $(detailsSelector)).html(
                  getIcon(lieferanzeige, circle_green_full)
                );
              }
            }

            if ($(itemSelector).length) {
              $(itemSelector).each(function () {
                let dropshipping = $(this).data("dropshipping"),
                  has_nachlieferung = $(this).data("has_nachlieferung"),
                  lieferanzeige = $(this).data("lieferanzeige");

                if (dropshipping && !has_nachlieferung) {
                  $(".product__delivery", $(this)).text(
                    `${brandData.numberOfDeliveryDays} ${window.productStrings.workingDays}`
                  );
                  // console.log("lieferanzeige", lieferanzeige);
                  $(".cart-item__lieferung .cf_lieferzeit_icon", $(this)).html(
                    getIcon(lieferanzeige, circle_green_full)
                  );
                }
              });
            }
          } else {
            // console.log("Failed to fetch or invalid brandData.");

            if ($(cardSelector).length) {
              $(cardSelector).each(function () {
                let dropshipping = $(this).data("dropshipping"),
                  has_nachlieferung = $(this).data("has_nachlieferung"),
                  lieferanzeige = $(this).data("lieferanzeige");

                if (dropshipping && !has_nachlieferung) {
                  $(".product__delivery", $(this)).attr(
                    "data-liefertage",
                    `${window.productStrings.deliveryDateUnknown}`
                  );
                  // console.log("lieferanzeige", lieferanzeige);
                  $(".product__delivery p", $(this)).html(
                    getIcon("", circle_gray_qm)
                  );
                }
              });
            }

            if ($(detailsSelector).length === 1) {
              let dropshipping = $(detailsSelector).data("dropshipping"),
                has_nachlieferung =
                  $(detailsSelector).data("has_nachlieferung"),
                lieferanzeige = $(detailsSelector).data("lieferanzeige");

              if (dropshipping && !has_nachlieferung) {
                $(".cf_lieferzeit b", $(detailsSelector)).text(
                  `${window.productStrings.deliveryDateUnknown}`
                );
                // console.log("lieferanzeige", lieferanzeige);
                $(".cf_lieferzeit_icon", $(detailsSelector)).html(
                  getIcon("", circle_gray_qm)
                );
              }
            }

            if ($(itemSelector).length) {
              $(itemSelector).each(function () {
                let dropshipping = $(this).data("dropshipping"),
                  has_nachlieferung = $(this).data("has_nachlieferung"),
                  lieferanzeige = $(this).data("lieferanzeige");

                if (dropshipping && !has_nachlieferung) {
                  $(".product__delivery", $(this)).text(
                    `${window.productStrings.deliveryDateUnknown}`
                  );
                  // console.log("lieferanzeige", lieferanzeige);
                  $(".cart-item__lieferung .cf_lieferzeit_icon", $(this)).html(
                    getIcon("", circle_gray_qm)
                  );
                }
              });
            }
          }
          $(".pro_custom_fields-skeleton-loader").remove();
        } catch (error) {
          console.error("Error fetching brandData:", error);
        }
      });
    }
  }
});